import { useHistory } from "react-router-dom";

/* Styles */
import styles from 'styles/login.module.scss';
import industryCardsStyles from 'styles/industry-cards.module.scss';
import layoutStyles from 'styles/layout.module.scss';
import onboardingStyles from 'styles/onboarding.module.scss';
import cn from 'classnames';

/* i18n */
import { useIntl } from 'react-intl';

/* API */
import { postProfile } from 'lib/API';

/* Material UI and other UI Dependencies */
import Typography from "@material-ui/core/Typography";
import OnboardingSteps from 'components/OnboardingSteps';
import { Box } from "@material-ui/core";
import GoalCard from 'components/GoalCard';

/* Analytics */
import { trackEvent } from 'lib/analytics';

/* Redux */
import { useDispatch, useSelector } from 'react-redux';
import { setLoadingRecommendations, setNeedsOnboarding, setUnrecoverableError } from 'app/slices/appSlice';
import { setGoal, setCareers } from 'app/slices/careersSlice';
import { setJobs } from 'app/slices/jobsSlice';
import { setTraining } from 'app/slices/trainingSlice';
import { setExperienceSkills } from 'app/slices/experienceSlice';

export default function OnboardingGoals() {

  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const experienceForm = useSelector((state) => state.experience.form);
  const skills = useSelector((state) => state.experience.skills);
  const urlPrefix = intl.locale === 'en' ? '' : `/${intl.locale}`;

  const handleCardClick = (goal) => () =>  {
    dispatch(setLoadingRecommendations(true));
    trackEvent('ONBOARDING_GOAL', goal);
    dispatch(setGoal(goal));
    let values = {
      ...experienceForm,
      goal,
      skills,
      action: 'recommend',
      language: intl.locale
    };
    postProfile(values).then(function(response) {
      dispatch(setCareers(response.careers.value));
      dispatch(setJobs(response.jobs.value));
      dispatch(setTraining(response.training.value));
      dispatch(setExperienceSkills(response.skills.value));
      dispatch(setNeedsOnboarding(false));
      history.push(`${urlPrefix}/careers`);
      dispatch(setLoadingRecommendations(false));
    }).catch(function(error) {
      dispatch(setUnrecoverableError(true));
    });
  }

  const goals = ['boostEarnings', 'similarSkills', 'manyJobs'];

  return (
    <>
      <div className={styles.loginFlow__form__onboarding}>
        <Box px={3} className={onboardingStyles.goalsTitle}>
          <Typography align="center" variant="h1" gutterBottom>
            {intl.formatMessage({id:'onboarding.goals.title',description:'string'})}
          </Typography>
        </Box>        
        <OnboardingSteps activeStep={2} />
      </div>
      <hr className={layoutStyles.separatorBold} />
      <div className={onboardingStyles.goalsContainer}>
        <div className={industryCardsStyles.container}>
          {goals.map(i => (
            <GoalCard type={i} key={i} onClick={handleCardClick(i)} />
          ))}
        </div>
        <div className={onboardingStyles.goalsLinkContainer}>
          <span
            onClick={handleCardClick('notSure')}
            className={cn(layoutStyles.link, onboardingStyles.notSureLink)}
          >
            {intl.formatMessage({id:'onboarding.goals.notSure',description:'string'})}
          </span>
        </div>
      </div>
    </>
  );
}